export const KEY_NEWS_API = "d3b9527b6e7c4ae48fc7f2a1c8aba334";
